export class PaneInfoRenderer {
    static imageCache = new Map();
    static pendingRedraws = new Map();

    constructor(data) {
        this.data = data;
    }

    drawText(scope) {
        const ctx = scope.context;
        const { x, y } = this.data.padding;
        ctx.save();

        const padding = 8;
        const lineH = 20;
        const width = 320;
        const height = lineH + padding * 2;

        ctx.fillStyle = "rgba(30,33,36,0)";
        ctx.beginPath();
        ctx.roundRect(x, y, width, height, 4);
        ctx.fill();

        ctx.font = '14px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
        ctx.textBaseline = "middle";

        let paddingX = x + padding;
        const content = this.data.content;
        content.forEach((seg) => {
            if (seg.icon) {
                let img = PaneInfoRenderer.imageCache.get(seg.icon);
                if (!img) return;
                if (img.complete && img.naturalWidth > 0) {
                    const imgSize = 24;
                    const paddingY = y + padding + (lineH - imgSize) / 2;
                    ctx.drawImage(img, paddingX, paddingY, imgSize, imgSize);
                }
                paddingX += 24 * 1.2;
            } else if (seg.text) {
                ctx.fillStyle = seg.color || "#aaa";
                ctx.fillText(seg.text, paddingX, y + padding + lineH / 2);
                paddingX += ctx.measureText(seg.text).width;
            }
        });

        ctx.restore();
    }

    draw(target) {
        if (!this.data.visible || !this.data.content.length) return;
        target.useMediaCoordinateSpace((scope) => this.drawText(scope));
    }
}

export class PaneInfoPaneView {
    constructor(source) {
        this._source = source;
    }
    update() {}
    renderer() {
        return new PaneInfoRenderer(this._source.renderData);
    }
}

export class PaneInfoPrimitive {
    constructor({ padding = { x: 0, y: 0 }, chartType = "line", seriesRef, itemIcon, itemName, currencyIcon, activeTab, indicators }) {
        this.renderData = {
            content: [],
            visible: true,
            padding,
            getChart: () => this.chart(),
        };
        this._paneViews = [new PaneInfoPaneView(this)];
        this.didLoadImages = false;
        this.chartType = chartType;
        this.seriesRef = seriesRef;
        this.itemIcon = itemIcon;
        this.itemName = itemName;
        this.currencyIcon = currencyIcon;
        this.activeTab = activeTab;
        this.indicators = indicators;
    }

    async updateContent(content) {
        this.renderData.content = content;

        if (!this.didLoadImages) {
            const images = (
                await Promise.all(
                    content.map((seg) => {
                        if (seg.icon) {
                            return loadImage(seg.icon);
                        }
                        return null;
                    })
                )
            ).filter(Boolean);

            if (images.length) {
                this.didLoadImages = true;
                images.forEach((img) => {
                    PaneInfoRenderer.imageCache.set(img.src, img);
                });

                this.requestUpdateSafe();
            }
        } else {
            this.requestUpdateSafe();
        }
    }
    setVisible(v) {
        this.renderData.visible = v;
    }
    paneViews() {
        return this._paneViews;
    }
    updateAllViews() {
        this._paneViews.forEach((v) => v.update());
    }
    requestUpdateSafe() {
        if (this.requestUpdate) {
            this.requestUpdate();
        }
    }
    attached(param) {
        this._attachedParams = param;
        this.requestUpdate = param.requestUpdate;
        param.chart.subscribeCrosshairMove(this.onMouseMove);
        this.onAttach();
    }
    detached() {
        const chart = this.chart();
        if (chart) {
            chart.unsubscribeCrosshairMove(this.onMouseMove);
        }
    }
    chart() {
        return this._attachedParams?.chart;
    }
    series() {
        return this.seriesRef.current;
    }
    onAttach() {}
}

function loadImage(url) {
    return new Promise((resolve, reject) => {
        const img = new window.Image();
        img.src = url;
        if (img.complete && img.naturalWidth > 0) {
            resolve(img);
        } else {
            img.onload = () => resolve(img);
            img.onerror = reject;
        }
    });
}
